module.exports = __webpack_public_path__ + "3c40d449b1af5ac81528c0c8e9391f47.cur";


//////////////////
// WEBPACK FOOTER
// ./app/assets/icons/cursors/circles/cur/circle-32.cur
// module id = 452
// module chunks = 0